import { TOOLS_GEN } from "./tools_gen";

export function tg(lang, key) {
  return (TOOLS_GEN[lang] || TOOLS_GEN.fr)[key] || TOOLS_GEN.fr[key];
}
export const toolsPath = (lang) => (lang === "fr" ? "/outils" : `/${lang}/outils`);
